import APICredential, {ContentType} from "ct-library-api-credential";

export const apiCredential = new APICredential({
  baseURL: process.env.REACT_APP_SERVER_URL as string,
  refreshAPI: {
    path: "",
    method: "",
    type: ContentType.Json,
    format: "json",
  },
});
